import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../utils/loadable';
import { isEnableFwaRedesignFFlag } from '../../../components/common/Helpers';

const PopularPlansComponent = isEnableFwaRedesignFFlag() ? Loadable(() => import('../containers/redesign/index')) : Loadable(() => import('../containers/index'));

export default MapTo('vcg/components/soe-home/react/popularplans')(PopularPlansComponent);
